/* Dieren Drukwerk — thema-scripts */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var nav = $('[data-nav]');
    var overlay = $('.nav-overlay');
    if (!nav) return;
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', function () { if (a.getAttribute('href').indexOf('#') > -1) setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- Bladerboek ---------- */
  function initFlip(root) {
    var pages = $$('[data-flip-page]', root);
    if (!pages.length) return;
    var cur = $('[data-flip-current]', root), prev = $('[data-flip-prev]', root), next = $('[data-flip-next]', root), range = $('[data-flip-range]', root);
    var i = 0;
    var go = function (n) {
      i = Math.max(0, Math.min(pages.length - 1, n));
      pages.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      // laad de volgende alvast
      [i + 1, i + 2].forEach(function (k) { var im = pages[k] && pages[k].querySelector('img'); if (im) im.loading = 'eager'; });
      if (cur) cur.textContent = i + 1;
      if (range) range.value = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === pages.length - 1;
    };
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (range) range.addEventListener('input', function () { go(parseInt(range.value, 10) - 1); });
    root.tabIndex = 0;
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
    });
    var stage = $('.flip__stage', root), x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    stage.addEventListener('click', function (e) {
      var r = stage.getBoundingClientRect();
      go(i + (e.clientX - r.left > r.width / 2 ? 1 : -1));
    });
    go(0);
  }

  /* ---------- Boekmaker ---------- */
  function initBuilder(root) {
    var form = $('[data-book-form]', root) || $('#BookForm', root);
    if (!form) return;
    var steps = $$('[data-step]', form);
    var progress = $$('[data-progress] li', root);
    var btnPrev = $('[data-prev]', form), btnNext = $('[data-next]', form), btnSubmit = $('[data-submit]', form);
    var variantInput = $('[data-variant-input]', form), returnTo = $('[data-return-to]', form);
    var traitsInput = $('[data-traits-input]', form), refInput = $('[data-ref-input]', form);
    var sum = {
      img: $('[data-sum-img]', root), story: $('[data-sum-story]', root), pet: $('[data-sum-pet]', root),
      format: $('[data-sum-format]', root), price: $('[data-sum-price]', root)
    };
    var MAX = 20 * 1024 * 1024;
    var step = 1;
    var params = new URLSearchParams(window.location.search);

    var storyKey = function () { var r = $('input[name="properties[Verhaal]"]:checked', form); return r ? r.getAttribute('data-story-key') : ''; };
    var format = function () { return $('input[name="dd_format"]:checked', form); };

    function setError(field, on) { if (field) field.classList.toggle('has-error', !!on); }

    function applyConditions() {
      var key = storyKey();
      $$('[data-show-for]', form).forEach(function (el) {
        var show = el.getAttribute('data-show-for').split(' ').indexOf(key) > -1;
        el.classList.toggle('is-shown', show);
        $$('input, select, textarea', el).forEach(function (f) { f.disabled = !show; });
      });
      $$('[data-required-for]', form).forEach(function (f) {
        f.required = f.getAttribute('data-required-for').split(' ').indexOf(key) > -1;
      });
      $$('[data-req-for]', form).forEach(function (s) { s.hidden = s.getAttribute('data-req-for').split(' ').indexOf(key) < 0; });
      var label = $('[data-moments-label]', form);
      if (label) label.textContent = (key === 'levensverhaal' || key === 'herinneringen') ? 'Mooie momenten en anekdotes' : 'Wat doet je dier altijd? Wat moet er zeker in het boek?';
    }

    function updateSummary() {
      var s = $('input[name="properties[Verhaal]"]:checked', form);
      if (s && sum.story) {
        sum.story.textContent = s.value;
        var im = s.closest('.choice').querySelector('[data-story-img]');
        if (im && sum.img) sum.img.src = im.currentSrc || im.src;
      }
      var name = $('[data-sum-name]', form);
      var n = name && name.value.trim();
      if (sum.pet) sum.pet.textContent = n || '–';
      $$('[data-pet-name]', root).forEach(function (el) { el.textContent = n || 'je huisdier'; });
      var f = format();
      if (f) {
        if (sum.format) sum.format.textContent = f.getAttribute('data-label');
        if (sum.price) sum.price.textContent = f.value === 'proef' ? 'Gratis' : f.getAttribute('data-price');
        variantInput.value = f.getAttribute('data-variant');
        var isProef = f.value === 'proef';
        returnTo.value = isProef ? '/checkout' : '/cart';
        var lbl = $('[data-submit-label]', form);
        if (lbl) lbl.textContent = btnSubmit.getAttribute(isProef ? 'data-label-proef' : 'data-label-buy');
        var legal = $('[data-legal-proef]', form);
        if (legal) legal.hidden = !(isProef && step === steps.length);
      }
    }

    function validate(n) {
      var ok = true, el = steps[n - 1];
      if (n === 1) {
        ok = !!storyKey();
        var err = $('[data-error-story]', form);
        if (err) err.style.display = ok ? 'none' : 'block';
        return ok;
      }
      $$('input, select, textarea', el).forEach(function (f) {
        if (f.disabled || !f.required) return;
        var field = f.closest('.field');
        var valid;
        if (f.type === 'radio') valid = !!$('input[name="' + f.name + '"]:checked', el);
        else if (f.type === 'checkbox') valid = f.checked;
        else if (f.type === 'file') valid = f.files && f.files.length > 0;
        else valid = f.value.trim() !== '';
        setError(field, !valid);
        if (!valid) ok = false;
      });
      if (n === 3) {
        var tooBig = $$('[data-upload]', el).some(function (f) { return f.files[0] && f.files[0].size > MAX; });
        var e2 = $('[data-error-size]', el);
        if (e2) e2.style.display = tooBig ? 'block' : 'none';
        if (tooBig) ok = false;
      }
      if (!ok) {
        var first = $('.has-error', el);
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }

    function show(n, scroll) {
      step = n;
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n - 1); });
      progress.forEach(function (p, k) {
        p.classList.toggle('is-active', k === n - 1);
        p.classList.toggle('is-done', k < n - 1);
      });
      btnPrev.hidden = n === 1;
      btnNext.hidden = n === steps.length;
      btnSubmit.hidden = n !== steps.length;
      updateSummary();
      if (scroll) {
        var top = root.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    btnNext.addEventListener('click', function () { if (validate(step)) show(step + 1, true); });
    btnPrev.addEventListener('click', function () { show(step - 1, true); });
    progress.forEach(function (p, k) {
      p.style.cursor = 'pointer';
      p.addEventListener('click', function () {
        var target = k + 1;
        if (target < step) return show(target, true);
        for (var s = step; s < target; s++) { if (!validate(s)) return show(s, true); }
        show(target, true);
      });
    });

    form.addEventListener('change', function (e) {
      if (e.target.name === 'properties[Verhaal]') {
        applyConditions();
        var err = $('[data-error-story]', form); if (err) err.style.display = 'none';
      }
      var field = e.target.closest && e.target.closest('.field');
      if (field && field.classList.contains('has-error')) setError(field, false);
      updateSummary();
    });
    form.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-sum-name')) updateSummary();
      var field = e.target.closest && e.target.closest('.field');
      if (field && field.classList.contains('has-error') && e.target.value.trim()) setError(field, false);
    });

    // Karaktereigenschappen samenvoegen tot één property
    var traitsWrap = $('[data-traits]', form);
    if (traitsWrap) traitsWrap.addEventListener('change', function () {
      var vals = $$('input:checked', traitsWrap).map(function (i) { return i.value; });
      traitsInput.value = vals.join(', ');
      traitsInput.disabled = vals.length === 0;
    });

    // Foto-previews
    $$('[data-upload]', form).forEach(function (input) {
      var box = input.closest('.uploader'), img = $('[data-preview]', box), clear = $('[data-clear]', box);
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) { box.classList.remove('has-file'); return; }
        box.classList.add('has-file');
        try { img.src = URL.createObjectURL(f); } catch (err) { /* geen preview mogelijk */ }
        setError(input.closest('.field'), false);
      });
      clear.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        input.value = ''; img.removeAttribute('src'); box.classList.remove('has-file');
      });
    });

    form.addEventListener('submit', function (e) {
      for (var s = 1; s <= steps.length; s++) {
        if (!validate(s)) { e.preventDefault(); show(s, true); return; }
      }
      if (!variantInput.value) { e.preventDefault(); alert('Dit product heeft nog geen varianten. Zie de installatie-uitleg.'); return; }
      // lege velden niet meesturen, zodat de bestelling overzichtelijk blijft
      $$('input, select, textarea', form).forEach(function (f) {
        if (f.disabled || f.type === 'hidden' || f.type === 'radio' || f.type === 'checkbox') return;
        var empty = f.type === 'file' ? !(f.files && f.files.length) : !String(f.value).trim();
        if (empty) { f.disabled = true; f.setAttribute('data-was-empty', ''); }
      });
      $$('input[name="dd_format"]', form).forEach(function (r) { r.disabled = true; r.setAttribute('data-was-empty', ''); });
      root.classList.add('is-submitting');
      var label = $('[data-submit-label]', form); if (label) label.textContent = 'Even geduld, foto’s uploaden…';
    });

    // Startstand uit de URL: ?verhaal=avontuur&formaat=hardcover&proef=ABC123
    var startStep = 1;
    var v = params.get('verhaal');
    if (v) {
      var r = $('input[data-story-key="' + v + '"]', form);
      if (r) { r.checked = true; startStep = 2; }
    }
    var fm = params.get('formaat');
    if (fm) { var fr = $('input[name="dd_format"][value="' + fm + '"]', form); if (fr && !fr.disabled) fr.checked = true; }
    var ref = params.get('proef');
    if (ref && refInput) {
      refInput.value = ref.slice(0, 40); refInput.disabled = false;
      var proef = $('input[name="dd_format"][value="proef"]', form);
      if (proef && proef.checked) { var alt = $('input[name="dd_format"][value="hardcover"]', form) || $('input[name="dd_format"][value="ebook"]', form); if (alt) alt.checked = true; }
    }
    // terug via de browserknop: velden weer bruikbaar maken
    window.addEventListener('pageshow', function () {
      $$('[data-was-empty]', form).forEach(function (f) { f.disabled = false; f.removeAttribute('data-was-empty'); });
      root.classList.remove('is-submitting');
      applyConditions();
      updateSummary();
    });

    applyConditions();
    show(startStep, false);
  }

  /* ---------- Winkelwagen ---------- */
  function initCart() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button[data-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-step'), 10);
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + d);
          var f = input.form; if (f) f.submit();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    $$('[data-flip]').forEach(initFlip);
    $$('[data-builder]').forEach(initBuilder);
    initCart();
  });
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-flip]', e.target).forEach(initFlip);
    $$('[data-builder]', e.target).forEach(initBuilder);
  });
})();
